import { GridColumnVisibilityModel, GridSortModel } from '@mui/x-data-grid';
import { atom } from 'jotai';

import { SearchTemplate } from '@/types';

export const DEFAULT_SEARCHES_PAGE_SIZE = 10;

export type Auth0Snapshot = {
  id: string;
  label: string;
};

export const searchNameAtom = atom<string>('');
export const searchTypeAtom = atom<string>('');
export const searchDescriptionAtom = atom<string>('');
export const searchCreatedByAtom = atom<Auth0Snapshot | null>(null);
export const searchSortAtom = atom<GridSortModel>([{ field: 'createdAt', sort: 'desc' }]);
export const searchColumnVisibilityAtom = atom<GridColumnVisibilityModel>({
  id: false,
});
export const searchPageSizeAtom = atom<number>(DEFAULT_SEARCHES_PAGE_SIZE);
export const searchPageNoAtom = atom<number>(0);

export const searchTemplateSortAtom = atom<GridSortModel>([{ field: 'createdAt', sort: 'desc' }]);
export const searchTemplateColumnVisibilityAtom = atom<GridColumnVisibilityModel>({
  id: false,
});
export const searchTemplatePageSizeAtom = atom<number>(DEFAULT_SEARCHES_PAGE_SIZE);
export const searchTemplatePageNoAtom = atom<number>(0);
export const searchTabSelectionAtom = atom<'Saved Searches' | 'Templates'>('Saved Searches');

export const searchTemplateNameAtom = atom<string>('');
export const searchTemplateDescriptionAtom = atom<string>('');
export const searchTemplateCreatedByAtom = atom<Auth0Snapshot | null>(null);

export const searchTemplateForCopyAtom = atom<SearchTemplate | undefined>(undefined);
